<template>
<div style="width: 100%;">

  <div class="articleboxes">

    <div class="articlebox" :class="{ 's_loading' : isLoading }" v-for="post in paginatedPosts" v-bind:key="post.id">
      <a :href=post.url class="articlebox-imagecontainer">
        <img :src=post.thumbUrl :data-src=post.imageUrl alt="" class="articlebox-image lazyload">
      </a>
      <div class="articlebox-content">
        <h4 class="articlebox-tags">
          <a :href=tag.url v-for="tag in post.tags.slice(0, 3)" v-html="tag.title"></a>
        </h4>
        <h4 class="articlebox-title"><a :href=post.url v-html="post.title"></a></h4>
        <a :href=post.url>Read more</a>
      </div>
    </div>

  </div>

  <div class="pagination" v-if="pageCount > 1 && pageNumber < pageCount">

    <button @click="nextPage" class="pagination-link">
      Load more
    </button>

  </div>

</div>
</template>

<script>
import EventBus from '../utils/event-bus';
import FilterSelect from "../components/Filter-Select";
import FilterText from "../components/Filter-Text";

export default {
  name: "PostsFilter",
  data() {
    return {

      keywords: '',
      category: false,
      hasResults: false,
      isEmpty: false,
      isLoading: false,
      filteredPosts: [],
      pageNumber: 1

    };
  },
  props: {
    categories: Array,
    posts: Array,
    tag: String,
    categoryCode: {
      type: String,
      default: 'category'
    },
    categoryCodePlural: {
      type: String,
      default: 'categories'
    },
    pageStart: {
      type: Number,
      required: false,
      default: 1
    },
    postsPerPage: {
      type: Number,
      required: false,
      default: 20
    }
  },
  computed: {

    pageCount() {
      let l = this.filteredPosts.length,
          s = this.postsPerPage;
      return Math.ceil(l/s);
    },

    paginatedPosts() {
      const start = 0, //(this.pageNumber - 1) * this.postsPerPage,
            end = ( (this.pageNumber - 1) * this.postsPerPage ) + this.postsPerPage;
      return this.filteredPosts.slice(start, end);
    },

    pageChoices() {
      let start = 1,
          end = this.pageCount,
          pages = [];
      if (this.pageCount > 7) {
        if (this.pageNumber + 3 >= this.pageCount) {
          end = this.pageCount;
          start = end - 7;
        } else if (this.pageNumber - 3 <= 1) {
          start = 1;
          end = start + 7;
        } else {
          start = this.pageNumber - 3;
          end = this.pageNumber + 3;
          if (start < 1) {
            start = 1;
          }
          if (end > this.pageCount) {
            end = this.pageCount;
          }
        }
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      // console.log(pages);
      return pages;
    }

  },
  components: {
    FilterSelect,
    FilterText
  },
  methods: {

    filterPosts() {

      this.isLoading = true;
      var matchesRequired = 0;

      if (this.keywords) {
        matchesRequired++;
      }

      if (this.category) {
        matchesRequired++;
      }

      this.filteredPosts = this.posts.filter((post) => {
        var isValid = false;
        var matches = 0;

        if (this.keywords.length) {
          if (post.title.toLowerCase().indexOf(this.keywords.toLowerCase()) > -1) {
            matches++;
          }
        }

        if (this.category) {
          var tagsString = JSON.stringify(post.tags);
          if (tagsString.toLowerCase().indexOf(this.category.toLowerCase()) > -1) {
            matches++;
          }
        }

        if (matches == matchesRequired) {
          isValid = true;
        }
        return isValid;
      });

      setTimeout(() => {
        this.isLoading = false;
      }, 500);

    },

    changePage() {
      let url = window.location.href
      url = url.replace(/page\/[0-9]+\/?/g, "");
      url += 'page/' + this.pageNumber + '/';
      history.pushState(
        {},
        null,
        url
      );
    },

    nextPage() {
      this.pageNumber++;
      if (this.pageNumber > this.pageCount) {
        this.pageNumber = this.pageCount;
      }
      this.changePage();
    },

    prevPage() {
      this.pageNumber--;
      if (this.pageNumber < 1) {
        this.pageNumber = 1;
      }
      this.changePage();
    },

    gotoPage(n) {
      this.pageNumber = n;
      if (this.pageNumber < 1) {
        this.pageNumber = 1;
      }
      if (this.pageNumber > this.pageCount) {
        this.pageNumber = this.pageCount;
      }
      this.changePage();
    }

  },
  mounted() {

    EventBus.$on('FILTER_VAR', (varName, varVal) => {
      // console.log('i');
      // console.log(varName);
      // console.log(varVal);
      if (typeof varName !== 'undefined' && varName.length && typeof varVal !== 'undefined') {
        this[varName] = varVal;
        this.pageNumber = 1;
        this.filterPosts();
      }
    });

    this.pageNumber = this.pageStart;

    this.filterPosts();

  },
  updated() {
    lazySizes.init();
  }
};
</script>

<style scoped>
</style>